import * as ko from "knockout";

import {BaseGrid} from "Core/Controls/Grid/BaseGrid/BaseGrid";
import {EVENTS as GRID_EVENTS} from "Core/Controls/Grid/BaseGrid/Events";
import {Event} from "Core/Common/Event";
import {EVENTS} from "Core/Controls/Grid/BaseGrid/QueryResultPage/Events";
import {LABELS} from "Core/Components/Translation/Locales";

import Template from 'Core/Controls/Grid/BaseGrid/EditMultipleLinks/Template.html';
import { Modal } from "Core/Common/Modal";
import { GridDataModel, GridStore } from "Core/Controls/Grid/BaseGrid/Index";
import {MobileChecker} from "../../../../Common/MobileChecker";
import {MutationObserverConfig, RepositionModalObserver} from "../../../../Common/RepositionModalObserver";
import { IUnlinkMultipleRecordsRequestModel } from "Core/Controls/Grid/Stores/GridStore";

ko.templates['Core/Controls/Grid/BaseGrid/EditMultipleLinks/Template'] = Template;

export interface EditMultipleLinksOptions {
    isNewLinks?: boolean;
}

export class EditMultipleLinks extends Event {
    readonly _grid: KnockoutObservable<BaseGrid>;
    private _modal: Modal;
    _labels = LABELS;
    private _observer: RepositionModalObserver;
    private _gridData: GridDataModel;
    private _subjectRecordId: number;
    private _subjectEntityId: number;
    private _isNewLinks: boolean;

    constructor(options?: EditMultipleLinksOptions) {
        super();
        this._grid = ko.observable(null);
        this._observer = null;
        this._isNewLinks = options?.isNewLinks ?? true;
    }

    Close() {
        if (this._modal) {
            this._observer && this._observer.Disconnect();
            this._modal.Close();
        }
    }

    SetData(gridData: GridDataModel, subjectEntityId: number, subjectRecordId: number) {
        this._subjectRecordId = subjectRecordId;
        this._subjectEntityId = subjectEntityId;

        this._gridData = gridData;
        let isEditable = ko.observable(false);
        const grid = new BaseGrid({
            isPrioritiesDisabled: true,
            isQueryResultGrid: true,            
            isEditable: isEditable,
            screenType: null,
            enabledFavorite: false,
            isEnableSelectRecord: ko.observable(false)
        });

        this._grid(grid);

        this._grid().On(GRID_EVENTS.DATA_SAVED, this, () => {
            this.Trigger(GRID_EVENTS.REFRESH);
        });

        grid.SetData(gridData, false, true);
        grid.EditAll();
        isEditable(false);
    }

    Show() {
        let self = this;
        let isMobile = MobileChecker.IsMobile();
        this._modal = new Modal({
            minWidth: 350,
            minHeight: 150,
            maxHeight: '75vh',
            maxWidth: '85vw',
            addClass: isMobile ? 'mobile-padding edit-multiple-links-popup' : 'edit-multiple-links-popup',
            closeOnEsc: false,
            blockScroll: true,
            onOpen: function () {
                const target: HTMLElement = this.wrapper.find('.jBox-content')[0];
                const mutationObserverConfig: MutationObserverConfig = {
                    attributes: true,
                    childList: true,
                    characterData: true,
                    subtree: true,
                }
                self._observer = new RepositionModalObserver(target, mutationObserverConfig);
            }
        }, false);
        this._modal.One('CLOSE', this, () => { this.Close() });

        ko.cleanNode(this._modal.Wrapper);
        ko.applyBindings(this, this._modal.Wrapper);
        this._modal.Show();
    }

    GetTemplateName() {
        return 'Core/Controls/Grid/BaseGrid/EditMultipleLinks/Template';
    }

    Save(){        
        let isValid = true;

        this._grid().Rows.forEach(row=>{
            row.DataCells.forEach(item=>{
                item.SaveControlValue(row.GetLinkEditorFieldData(item.Model.FieldMetadata.Id));
            });
            isValid = row.IsValid();
        });

        if(isValid){
            this._grid().SaveRecords(this._grid().Rows).then(()=>{
                this.Close();
            });
        }         
    }

    Cancel(){
        if (this._isNewLinks) {
            let request: IUnlinkMultipleRecordsRequestModel = {
                Rows: []
            }

            _.each(this._gridData.Rows, (row) => {
                request.Rows.push({
                    MainEntityId: this._subjectEntityId,
                    MainRecordId: this._subjectRecordId,
                    RelatedEntityId: row.EntityId,
                    RelatedRecordId: row.RecordId,
                    KSeq: row.KSeq
                });
            })

            GridStore.UnlinkMultipleRecords(request).then(() => {
                this.Trigger(GRID_EVENTS.REFRESH);
                this.Close();
            });
        } else {
            this.Close();
        }
    }
}